export const transformDataForFrontend = (hospitalData = []) => {
  return {
    hospitals: hospitalData?.map(({ name, location }) => ({ name, location })),
    facilities: [
      {
        label: "Ownership",
        values: hospitalData.map((h) => h.facilities?.ownership ?? "-"),
      },
      {
        label: "Facility Type",
        values: hospitalData.map((h) => h.facilities?.facility_type ?? "-"),
      },
      {
        label: "Geography",
        values: hospitalData.map((h) => h.facilities?.geography ?? "-"),
      },
      {
        label: "Hospital Beds",
        values: hospitalData.map((h) => addCommasToNumber(h.facilities?.hospital_beds) ?? "-"),
      },
      {
        label: "Patient Volume",
        values: hospitalData.map((h) => h.facilities?.patient_volume ?? "-"),
      },
      {
        label: "Hospital Area",
        values: hospitalData.map((h) => formatAreaSmart(h.facilities?.hospital_area) ?? "-"),
      },
      {
        label: "Discharges",
        values: hospitalData.map((h) =>
          h.facilities?.discharges != null ? h.facilities.discharges.toFixed(2) : "-"
        ),
      },
      {
        label: "Admissions",
        values: hospitalData.map((h) => addCommasToNumber(h.facilities?.admissions) ?? "-"),
      },
      {
        label: "Teaching Status",
        values: hospitalData.map((h) => h.facilities?.teaching_status ?? "-"),
      },
      {
        label: "NPI Number",
        values: hospitalData.map((h) => h.facilities?.npi_number ?? "-"),
      },
      {
        label: "Firm Type",
        values: hospitalData.map((h) => h.facilities?.firm_type ?? "-"),
      },
      {
        label: "Number of Employees",
        values: hospitalData.map((h) => addCommasToNumber(h.facilities?.number_employees) ?? "-"),
      },
      {
        label: "Number of Operating Rooms",
        values: hospitalData.map((h) => addCommasToNumber(h.facilities?.num_operating_rooms) ?? "-"),
      },
      {
        label: "340B ID",
        values: hospitalData.map((h) => h.facilities?.program_340b_id ?? "-"),
      },
      {
        label: "340B ID Classification",
        values: hospitalData.map((h) => h.facilities?.hospital_340b_id_classification ?? "-"),
      },
      {
        label: "Number of Affiliated Physicians",
        values: hospitalData.map((h) => addCommasToNumber(h.facilities?.number_affiliated_physicians) ?? "-"),
      },
      {
        label: "Readmission Reduction Penalty Score",
        values: hospitalData.map((h) => h.facilities?.readmission_reduction_penalty_score ?? "-"),
      },
      // {
      //   label: "Website",
      //   values: hospitalData.map((h) => h.facilities?.website ?? "-"),
      // },
    ],
    financials: [
      {
        label: "Gross Revenue",
        values: hospitalData.map((h) =>
          formatNumber(h.financials?.gross_revenue),
        ),
        // badge: hospitalData.map((h) => h.badges.gross_revenue),
      },
      {
        label: "Net Revenue",
        values: hospitalData.map((h) => formatNumber(h.financials?.net_revenue)),
      },
      {
        label: "Net Patient Revenue",
        values: hospitalData.map((h) => formatNumber(h.financials?.net_patient_revenue ?? "-")),
      },
      {
        label: "Operating Income",
        values: hospitalData.map((h) => formatNumber(h.financials?.operating_income ?? "-")),
      },
      {
        label: "Total Operating Expenses",
        values: hospitalData.map((h) => formatNumber(h.financials?.tot_operating_expenses ?? "-")),
      },
      {
        label: "Net Income",
        values: hospitalData.map((h) => formatNumber(h.financials?.net_income ?? "-")),
      },
      {
        label: "Net Income Margin",
        values: hospitalData.map((h) => (h.financials?.net_income_margin && h.financials?.net_income_margin !== '-'  ? `${h.financials?.net_income_margin}%` : "-")),
      },
      {
        label: "Outpatient Revenue",
        values: hospitalData.map((h) => formatNumber(h.financials?.outpatient_revenue ?? "-")),
      },
      {
        label: "Revenue to Cost Ratio",
        values: hospitalData.map((h) => h.financials?.revenue_to_cost_ratio ?? "-"),
      },
      {
        label: "Net Revenue Oncology",
        values: hospitalData.map((h) => formatNumber(h.financials?.net_revenue_oncology ?? "-")),
      },
      {
        label: "Bad Debt Percentage",
        values: hospitalData.map((h) =>
          formatPercentage(h.financials?.bad_debt_percentage ?? "-"),
        ),
        // badge: hospitalData.map((h) => h.badges.bad_debt_percentage),
      },
    ],
    affiliations: [
      {
        label: "Medical School Affiliation",
        values: hospitalData[0]?.medical_school_affiliation ?? "-",
      },
    ],
    accreditations: [
      {
        label: "Accreditations",
        values: hospitalData.map(hospital => splitAndClean(hospital.accreditations)),
      },
    ],
    oncology_focus: [
      {
        label: "Radiation Therapy",
        values: hospitalData[0]?.oncology_focus?.radiation_therapy ?? "-",
      },
      {
        label: "Chemo Therapy",
        values: hospitalData[0]?.oncology_focus?.chemo_therapy ?? "-",
      },
      {
        label: "Surg Onc.",
        values: hospitalData[0]?.oncology_focus?.procedures ?? "-",
      },
    ],
    oncology_research: [
      {
        label: "Tumor Board",
        values: hospitalData[0]?.oncology_research?.tumor_board ?? "-",
      },
      {
        label: "Participation in clinical trials",
        values:
          hospitalData[0]?.oncology_research?.participation_in_clinical_trials ?? "-",
      },
      {
        label: "Research affiliations",
        values: hospitalData[0]?.oncology_research?.research_affiliations ?? "-",
      },
    ],
    accessibility_inclusivity: [
      {
        label: "Geographic Accessibility",
        values: hospitalData.map(
          (h) => h.accessibility_inclusivity?.geographic_accessibility ?? "-",
        ),
      },
      {
        label: "Oncology Aid Programs",
        values: hospitalData.map(
          (h) => h.accessibility_inclusivity?.oncology_aid_programs ?? "-",
        ),
      },
      {
        label: "Language Assistance Services",
        values: hospitalData.map(
          (h) => h.accessibility_inclusivity?.language_assistance_services ?? "-",
        ),
      },
    ],

    quality_of_care: [
      {
        label: "NCCN",
        values: hospitalData[0]?.quality_of_care?.nccn ?? "-",
      },
      {
        label: "C4QI",
        values: hospitalData[0]?.quality_of_care?.c4qi ?? "-",
      },
      {
        label: "Oncology Mortality",
        values: hospitalData[0]?.quality_of_care?.oncology_mortality === "None%" ? "None" : formatPercentage(hospitalData[0]?.quality_of_care?.oncology_mortality ?? "-"),
      },
      {
        label: "Readmissions Rates",
        values: formatPercentage(hospitalData[0]?.quality_of_care?.readmissions_rate ?? "-"),
      },
      {
        label: "Overall Rating",
        values: hospitalData[0]?.quality_of_care?.overall_rating ?? "-",
      },
      {
        label: "HCAHPS",
        values: hospitalData[0]?.quality_of_care?.hcahps ?? "-",
      },
    ],

    patient_experience: [
      {
        label: "Communication With Nurses/Doctors",
        values:
          hospitalData[0]?.patient_experience?.communication_with_nurses_doctors ?? "-",
      },
      {
        label: "Appointment Wait Times",
        values: hospitalData[0]?.patient_experience?.appointment_wait_times ?? "-",
      },
      {
        label: "Cleanliness and Quietness",
        values: hospitalData[0]?.patient_experience?.cleanliness_and_quietness ?? "-",
      },
      {
        label: "Likelihood of Recommendation",
        values: hospitalData[0]?.patient_experience?.likelihood_of_recommendation ?? "-",
      },
      {
        label: "Cancer Navigation Program",
        values: hospitalData[0]?.patient_experience?.cancer_navigation_program ?? "-",
      },
    ],
  };
};

// function formatNumber(input) {
//   if (input == "-" || input == "$-") return "-";
//   let num = parseFloat(input.replace(/[$,]/g, ""));
//   if (num >= 1e9) {
//     return `$${(num / 1e9).toFixed(2)}B`;
//   } else if (num >= 1e6) {
//     return `$${(num / 1e6).toFixed(2)}M`;
//   } else {
//     return `$${num.toLocaleString()}`;
//   }
// }

export function formatNumber(input) {
  if (input === "-" || input === "$-" || input === "" || input == "$$0.00" || input === "-%") return "-";

  // Step 1: Remove all non-digit/minus/dot characters
  let numStr;
  if (input)
    numStr = input?.replace(/[^0-9-.]/g, "");

  // Step 2: Handle Indian comma system (e.g., "70,25,24,800.00" → "702524800.00")
  if (numStr.includes(",")) {
    numStr = numStr?.replace(/,/g, "");
  }

  // Step 3: Split into integer and decimal parts
  const [integerPart, decimalPart] = numStr.split(".");

  const num = parseFloat(integerPart);

  if (isNaN(num)) return "-";

  const absNum = Math.abs(num);
  const sign = num < 0 ? "-" : "";

  if (absNum >= 1e9) {
    return `${sign}$${(absNum / 1e9).toFixed(2)}B`;
  } else if (absNum >= 1e6) {
    return `${sign}$${(absNum / 1e6).toFixed(2)}M`;
  } else {
    return `${sign}$${absNum.toLocaleString()}`;
  }
}

export function formatPercentage(input) {
  if (input == "-" || input == "-%") return "-";
  let num = parseFloat(input.replace("%", ""));

  if (isNaN(num)) {
    return "-";
  } else if (num === 0) {
    return "0%";
  } else if (Math.abs(num) < 1) {
    // Keep significant digits so very small values (e.g. 0.000261) are not
    // rounded down to "0.000".
    return parseFloat(num.toPrecision(3)) + " %";
  } else {
    return num.toFixed(2) + " %";
  }
}

export function formatAreaSmart(input) {
  if (input == "-") return "-";
  let area = parseInt(input.replace(/\D/g, ""), 10);

  const oneAcre = 43560; // 1 acre = 43,560 sq. ft.

  if (area >= oneAcre) {
    return (area / oneAcre).toFixed(2) + " acres";
  } else {
    return area.toLocaleString() + " sq. ft.";
  }
}

export function splitAndClean(text) {
  return text
    .split("\n") // Split by newline
    .map(item => item.trim().replace(/,$/, "")) // Trim spaces & remove trailing comma
    .filter(item => item !== ""); // Remove empty entries
}

export function addCommasToNumber(num) {
  if (num == null || num === "") return num;
  const numStr = String(num).replace(/,/g, '');

  // Check if it's a valid number
  if (!/^-?\d+$/.test(numStr)) return num; // Return original if not a number

  // Add commas (handles negative numbers)
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}